import useTopic from '../../hooks/useTopic';

import TaxonomyPage, { TaxonomyPageProps } from './TaxonomyPage';

interface TopicPageProps extends TaxonomyPageProps {
    slug: string;
}

function TopicPage({ slug, ...props }: TopicPageProps) {
    const { topic = null, notFound = false } = useTopic(slug);

    return <TaxonomyPage taxonomy={topic} notFound={notFound} {...props} />;
}

export default TopicPage;
